import React from 'react'
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from '@material-ui/core/Grid';
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import Validators from "../../constants/ValidatorTypes";
import FormComponent from "../../common/FormComponent";
import { withSnackbar } from "notistack";
import PrincipalForm from '../../components/forms/principal/PrincipalForm';
import { addPrincipal } from '../../services/principal/PrincipalService';

class AddPrincipal extends FormComponent {

    validationList = {
        name: [{ type: Validators.REQUIRED }],
    };

    constructor(props) {
        super(props);

        this.state = {
            data: props.data ? props.data : {},
            errors: {}
        };

        this.props.changeFullScreen(false);

        this.submit = this.submit.bind(this);

    }

    submit() {

        if (!this.validate()) {
            return;
        }

        this.showDrawerLoader();

        addPrincipal(this.transformRequest(this.state.data), this.props.cid).then(response => {
            if (!response.ok) {
                let messageKey = response.response.data.message;

                this.props.enqueueSnackbar(strings.principal.messages[messageKey], {
                    variant: "error"
                });

                this.handleError(messageKey);

                return;
            }

            this.props.enqueueSnackbar(strings.addPrincipal.added, { variant: 'success' });
            this.props.onFinish(response.data.principal);

            this.hideDrawerLoader();
        });
    }

    transformRequest(data) {
        return {
            ...data,
            userEmail: this.props.uemail,
            companyId: this.props.cid
        }
    }

    handleError(message) {

        switch (message) {
            case "PRINCIPAL_WITH_NAME_ALREADY_EXIST":
                this.setError("name", strings.principal.messages.PRINCIPAL_WITH_NAME_ALREADY_EXIST);
                break;
            case "PRINCIPAL_NOT_EXIST":
                this.setError("name", strings.principal.messages.PRINCIPAL_NOT_EXIST);
                break;
            case "PRINCIPAL_NAME_CANT_BE_NULL":
                this.setError("name", strings.principal.messages.PRINCIPAL_NAME_CANT_BE_NULL);
                break;
        }
    }

    render() {

        return (
            <Grid id='page' item md={12}>

                <div className='header'>
                    <h1>{strings.addPrincipal.pageTitle}</h1>
                </div>

                <Paper className='paper'>
                    <PrincipalForm onChange={this.changeData} onSubmit={this.submit}
                        data={this.state.data} errors={this.state.errors} onCancel={this.props.onCancel} />
                </Paper>

            </Grid>

        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen
    }, dispatch);
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
    return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AddPrincipal)));